import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { EAnalyticsEvents } from '@/_analytic/_types';
import { TArticleViewEventParams } from './_types';

export const articleViewEvent = (params: TArticleViewEventParams) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.ARTICLE_VIEW,
    params,
  });
};
